import { FormHelperText, FormLabel, Icon, Tooltip } from "@chakra-ui/react";
import { safeHTML } from "@lib/html";
import { DEFAULT_LANGUAGE, Language, translate as t } from "@models/language";
import { useMemo } from "react";
import { AiOutlineQuestionCircle, AiOutlineWarning } from "react-icons/ai";
import { Field, TooltipIcon } from "./types";

const DynamicFormFieldHeader = ({
  field,
  language: language = DEFAULT_LANGUAGE,
}: {
  field: Field;
  language?: Language;
}) => {
  const tooltipIcon = field.tooltipIcon || TooltipIcon.Info;
  const label = useMemo(
    () => t(field.label, language),
    [language, field.label]
  );
  return (
    <>
      {field.groupLabel && (
        <span className="flex mb-6">{t(field.groupLabel, language)}</span>
      )}
      <div className="flex flex-row items-center text-base">
        {field.icon && <Icon as={field.icon} mr={2} boxSize={4} />}
        {label && (
          <FormLabel
            htmlFor={field.key}
            minH={6}
            display="flex"
            alignItems="center"
          >
            {label}
          </FormLabel>
        )}
        {field.tooltip && (
          <Tooltip
            {...field.tooltipProps}
            label={t(field.tooltip, language)}
            placement="auto-start"
          >
            <div className="my-2 cursor-pointer text-primary">
              {tooltipIcon === TooltipIcon.Info && <AiOutlineQuestionCircle />}
              {tooltipIcon === TooltipIcon.Warning && (
                <AiOutlineWarning color="#D69E2E" />
              )}
            </div>
          </Tooltip>
        )}
      </div>
      <FormHelperText
        dangerouslySetInnerHTML={safeHTML(t(field.note, language))}
      ></FormHelperText>
    </>
  );
};

export default DynamicFormFieldHeader;
